<div class="filters row">
  <div class="r-form-group">
    <label class="title">{{'LEADS_MANAGMENT.BUSINESS' |translate}}</label>
    <p-autoComplete class="p-autoComplete" [(ngModel)]="selectedBusiness" [suggestions]="filteredBusinesses"
      (completeMethod)="filterBusinessNames($event)" field="Name" [dropdown]="true"
      [placeholder]="'LEADS_MANAGMENT.CHOOSE_BUSINESS'|translate" [forceSelection]="true" [showClear]="true"
      (onClear)="clearBusinessFilter()" (onSelect)="onBusinessSelected()">
    </p-autoComplete>
  </div>

  <div class="row">
    <div class="r-form-group">
      <label class="title">{{'LIDS.START_DATE' | translate}}</label>
      <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" selectionMode="range" [(ngModel)]="dateRange"
        [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()" (onSelect)="filterCreatedDate()"
        (onClickOutside)="filterCreatedDate()" appendTo="body">
      </p-calendar>
    </div>
  </div>
  <div class="r-form-group">
    <label class="title" for="category">{{'REGISTER.BUSINESS_AERA' | translate}}</label>
    <p-dropdown name="category" [appendTo]="null" [options]="allCategories" [(ngModel)]="selectedCategory"
      #category="ngModel" optionLabel="label" (onChange)="filterSelectCategory()" [filter]="true" filterBy="label"
      placeholder="{{'REGISTER.CHOOSE_BUSINESS_AREA' | translate}}" [showClear]="true">
    </p-dropdown>
  </div>
  <div class="r-form-group totalRecords">{{totalRecords}} {{'ROULETTE.LIDS'|translate}}</div>
  <app-atn-export-excel  [request]="request" [fileName]="'leadsForManager'"></app-atn-export-excel> 
</div>
<div class="table">
  <app-readonly-table #dt [columns]="columns" [selectionMode]="null" [itemsSource$]="lids$" [isFilterable]="false"
    [scrollable]="true" (sortChange)="onSort($event)" dataKey="CustomerId" [paginator]="true" (onLoadData)="onLoadData($event)" [isLoadLazy]="true"
    [totalRecords]="totalRecords" [rowsPerPageOptions]="null" (onViewDetails)="onOpenLidDetails($event)" >
  </app-readonly-table>
</div>
<p-dialog [(visible)]="viewLidDetails" class="dialog" [baseZIndex]="10000" [style]="{width: '608px', height:'720px'}"
    [draggable]="false" [resizable]="false"> 
     <app-lid-details-dialog *ngIf="viewLidDetails" [businessId]="lidDetails.BusinessId" [lidId]="lidId" [lidDetails]="lidDetails" (onCouponImplemented)="loadLids(); viewLidDetails=false"></app-lid-details-dialog>
</p-dialog>

